import { HttpResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DownloadFileService } from 'gung-standard';
import { first } from 'rxjs';
import { CrossReferenceImportReport } from '../../models/otto-olsen-cross-reference';
import { OttoOlsenCrossReferenceAdminService } from '../../services/otto-olsen-cross-reference-admin.service';
import { OttoOlsenCrossReferenceListConfigService } from '../../services/otto-olsen-cross-reference-list-config.service';
import { OttoOlsenCrossReferenceModalComponent } from '../otto-olsen-cross-reference-modal/otto-olsen-cross-reference-modal.component';

@Component({
  selector: 'otto-olsen-cross-reference-admin',
  templateUrl: './otto-olsen-cross-reference-admin.component.html',
  styleUrls: ['./otto-olsen-cross-reference-admin.component.scss'],
  standalone: false
})
export class OttoOlsenCrossReferenceAdminComponent {
  importing = false;
  importReport?: CrossReferenceImportReport;
  exporting = false;

  constructor(
    public listConfig: OttoOlsenCrossReferenceListConfigService,
    protected modalService: NgbModal,
    protected adminService: OttoOlsenCrossReferenceAdminService,
    protected downloadFileService: DownloadFileService
  ) {}

  add(): void {
    const ref = this.modalService.open(OttoOlsenCrossReferenceModalComponent, { size: 'lg' });
    ref.result.then(() => {}, () => {});
  }

  export(): void {
    if (this.exporting) {
      return;
    }
    this.exporting = true;
    this.adminService
      .exportExcel()
      .pipe(first())
      .subscribe({
        next: response => {
          this.exporting = false;
          if (!response.body) {
            return;
          }
          // The DownloadFileService extracts the filename from Content-Disposition
          // and triggers a normal browser download — no popup-blocker concerns.
          const file = this.downloadFileService.create(response as unknown as HttpResponse<ArrayBuffer>);
          this.downloadFileService.download(file);
        },
        error: () => (this.exporting = false)
      });
  }

  onFileSelected(input: HTMLInputElement): void {
    const file = input.files && input.files[0];
    if (!file) {
      return;
    }
    this.importing = true;
    this.importReport = undefined;
    this.adminService
      .importExcel(file)
      .pipe(first())
      .subscribe({
        next: report => {
          this.importing = false;
          this.importReport = report;
          input.value = '';
        },
        error: () => {
          this.importing = false;
          this.importReport = { applied: false, inserted: 0, updated: 0, errors: ['IMPORT_FAILED'] };
          input.value = '';
        }
      });
  }
}
